import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ALIGN, CONTENT_ALIGN } from './constants';
var MAP_ALIGNS = _defineProperty(_defineProperty(_defineProperty({}, ALIGN.Default, {
  header: CONTENT_ALIGN.Default,
  body: CONTENT_ALIGN.Default,
  footer: ALIGN.Vertical
}), ALIGN.Center, {
  header: CONTENT_ALIGN.Center,
  body: CONTENT_ALIGN.Center,
  footer: ALIGN.Center
}), ALIGN.Vertical, {
  header: CONTENT_ALIGN.Center,
  body: CONTENT_ALIGN.Center,
  footer: ALIGN.Vertical
});
export function getAlignProps(_ref) {
  var align = _ref.align;
  return MAP_ALIGNS[align];
}
export function getButtonsSize() {
  return 'm';
}